const blobToDataURL = async (blob: Blob): Promise<string | null> => {
  return new Promise((resolve: any) => {
    const fReader = new FileReader();
    fReader.onload = (e) => {
      resolve(e.target?.result);
    };
    fReader.readAsDataURL(blob);
  });
};

const downloadJsonFile = (objectData: any, name: string) => {
  const content = JSON.stringify(objectData, null, 2);
  const filename = `${name}.json`;
  const contentType = `application/json;charset=utf-8;`;
  const a = document.createElement(`a`);
  a.download = filename;
  a.href = `data:${contentType},${encodeURIComponent(content)}`;
  a.target = `_blank`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const getFileNameFromPath = (filePath: string) => {
  const parts = filePath.split(/[/\\]/);
  return parts[parts.length - 1];
};

export { blobToDataURL, downloadJsonFile, getFileNameFromPath };
